export const SAVE_CRITERIA = 'SAVE_CRITERIA';
export const SAVE_SEARCH_CRITERIA = 'SAVE_SEARCH_CRITERIA';
export const SAVE_GRID_CRITERIA = 'SAVE_GRID_CRITERIA';

export function saveCriteria(searchCriteria, gridCriteria) {
  return {
    type: SAVE_CRITERIA,
    searchCriteria,
    gridCriteria
  };
}

export function saveSearchCriteria(searchCrieria) {
  return {
    type: SAVE_SEARCH_CRITERIA,
    searchCrieria
  };
}

export function saveGridCriteria(gridCriteria) {
  return {
    type: SAVE_GRID_CRITERIA,
    gridCriteria
  };
}
